// Texte der Oberfläche für Nutzer, Rollen und Sicherheit (Runde 8, Agent 8C). Eigene Datei, damit `texte.ts` unberührt bleibt.
export const T8C = {
  nutzer: {
    einleitung:
      "Wer im CRM arbeiten darf, mit welcher Rolle, und was an ihm hängt. Neue Nutzer bekommen einen Einladungslink; es geht keine Mail automatisch raus.",
    einladen: "Nutzer einladen",
    spalteName: "Name",
    spalteRolle: "Rolle",
    spalteZweiFaktor: "Zwei-Faktor",
    spalteSchluessel: "Close-Schlüssel",
    zweiFaktorAn: "an",
    zweiFaktorAus: "aus",
    deaktiviert: "deaktiviert",
    neu: "neu",
    letzteAnmeldung: (wann: string) => `zuletzt angemeldet ${wann}`,
    nieAngemeldet: "noch nie angemeldet",
    keinZugang: "Kann sich nicht anmelden: weder eigenes Passwort noch Portal-Zugang.",
    schluesselEigen: (endung: string) => `eigener (…${endung})`,
    schluesselSystem: "Systemschlüssel",
    schluesselFehlt: "fehlt",
    schluesselNichtNoetig: "nicht nötig",
    schluesselEintragen: "Close-Schlüssel eintragen",
    schluesselPruefen: "Prüfen",
    schluesselGespeichert: (name: string) => `Close-Schlüssel für ${name} gespeichert.`,
    schluesselNichtGespeichert: "Schlüssel nicht gespeichert",
    menue: {
      aendern: "Name und Telefon ändern",
      schluessel: "Close-Schlüssel eintragen",
      zweiFaktorZuruecksetzen: "Zwei-Faktor zurücksetzen",
      deaktivieren: "Deaktivieren …",
      aktivieren: "Wieder aktivieren",
    },
    rolleGeaendert: (name: string, rolle: string) => `${name} ist jetzt ${rolle}.`,
    rolleNichtGeaendert: "Rolle nicht geändert",
    einladungen: "Offene Einladungen",
    einladungenLeer: "Keine offenen Einladungen.",
    einladungGueltig: (bis: string) => `gültig bis ${bis}`,
    einladungVon: (name: string) => `von ${name}`,
    einladungWiderrufen: "Widerrufen",
    einladungNeuerLink: "Neuen Link erzeugen",
    einladungWiderrufenOk: "Einladung widerrufen.",
    abgemeldet: "Beim Deaktivieren werden alle Sitzungen des Nutzers beendet.",
    nutzerLaden: "Nutzer konnten nicht geladen werden",
    keineAenderung: "Keine Änderung.",
  },
  einladen: {
    titel: "Nutzer einladen",
    email: "E-Mail-Adresse",
    emailHilfe: "Mit dieser Adresse meldet sich die Person später an.",
    rolle: "Rolle",
    erzeugen: "Link erzeugen",
    laeuft: "Wird erzeugt …",
    fertigTitel: "Einladungslink",
    fertigText: (email: string) =>
      `Schick diesen Link an ${email}, zum Beispiel per WhatsApp oder aus deinem Mailprogramm. Es geht keine Mail automatisch raus. Die Person wählt damit ihren Namen und ihr Passwort. Der Link gilt 7 Tage, funktioniert nur einmal und ist nur jetzt zu sehen.`,
    kopieren: "Link kopieren",
    kopiert: "Link kopiert.",
    schliessen: "Fertig",
    abbrechen: "Abbrechen",
  },
  bearbeiten: {
    titel: (name: string) => `${name} ändern`,
    vorname: "Vorname",
    nachname: "Nachname",
    telefon: "Handynummer",
    telefonHilfe: "Mit Vorwahl, zum Beispiel 0171 1234567. Wird für „Aufs Handy holen“ gebraucht.",
    speichern: "Speichern",
    abbrechen: "Abbrechen",
    gespeichert: "Gespeichert.",
    closeHinweis: "Solange der Abgleich mit Close läuft, bleibt der Name in Close wie er ist; im CRM gilt, was hier steht.",
  },
  deaktivieren: {
    titel: (name: string) => `${name} deaktivieren`,
    einleitung: (name: string) =>
      `${name} kann sich danach nicht mehr anmelden. Alle Sitzungen enden sofort. Die Daten bleiben erhalten, du kannst den Nutzer später wieder aktivieren.`,
    haengtAn: "Das hängt an dem Nutzer:",
    aufgaben: (n: number) => `${n} offene ${n === 1 ? "Aufgabe" : "Aufgaben"}`,
    opportunities: (n: number) => `${n} aktive ${n === 1 ? "Opportunity" : "Opportunities"}`,
    nummern: (n: number) => `${n} ${n === 1 ? "Rufnummer" : "Rufnummern"}`,
    nichtsDran: "Es hängt nichts an dem Nutzer, das umgehängt werden müsste.",
    systemaufgaben: (n: number) =>
      `${n} Systemaufgaben (verpasste Anrufe, Voicemails, SMS, fällige Opportunities) lassen sich in Close nicht umhängen und bleiben beim Nutzer.`,
    smartViews: (n: number) => `${n} geteilte Smart ${n === 1 ? "View" : "Views"} bleiben für alle sichtbar.`,
    offeneAnrufe: (n: number) => `Gerade läuft${n === 1 ? "" : "n"} noch ${n} ${n === 1 ? "Anruf" : "Anrufe"}. Der Nutzer wird danach abgemeldet.`,
    uebernimmt: "Wer übernimmt das?",
    waehlen: "Nutzer wählen …",
    kopfZeile: "Aufgaben und Opportunities gehen auch in Close an den neuen Zuständigen.",
    closeAenderung: (n: number, name: string) =>
      `Achtung: Das schreibt in Close. ${n} ${n === 1 ? "Eintrag wird" : "Einträge werden"} dort ${name} zugewiesen. Das lässt sich nur von Hand in Close zurückändern.`,
    knopf: "Deaktivieren",
    knopfMitClose: "Deaktivieren und in Close umhängen",
    laeuft: "Wird umgehängt …",
    abbrechen: "Abbrechen",
    fertig: (name: string) => `${name} ist deaktiviert.`,
    fehlerTitel: "Nicht alles ließ sich umhängen. Der Nutzer ist nicht deaktiviert.",
    fehlerWeiter: "Was schon umgehängt ist, bleibt so. Ein zweiter Versuch macht den Rest.",
  },
  aktivieren: { ok: (name: string) => `${name} ist wieder aktiv.` },
  zweiFaktorZuruecksetzen: {
    titel: (name: string) => `Zwei-Faktor von ${name} zurücksetzen`,
    text: "Die Person hat ihr Gerät verloren oder die Wiederherstellungscodes nicht mehr? Dann entfernst du Zwei-Faktor hier. Ihre Sitzungen enden, sie meldet sich danach wieder mit dem Passwort an. Verlangt die Organisation Zwei-Faktor, richtet sie es dabei neu ein.",
    knopf: "Zurücksetzen",
    ok: (name: string) => `Zwei-Faktor von ${name} ist zurückgesetzt.`,
  },
  rollen: {
    einleitung:
      "Jeder Nutzer hat eine Rolle, und die Rolle bestimmt, was er darf. Die vier Rollen aus Close sind fest; für eigene Wünsche legst du eine eigene Rolle an (am einfachsten als Kopie einer bestehenden).",
    neu: "Neue Rolle",
    nutzerAnzahl: (n: number) => (n === 1 ? "1 Nutzer" : `${n} Nutzer`),
    system: "fest",
    eigene: "eigene",
    basis: (name: string) => `wie ${name}`,
    rechte: "Rechte",
    rechteHilfe: "Haken = die Rolle darf es.",
    rechteFest: "Die Rechte der festen Rollen lassen sich nicht ändern. Für andere Rechte eine Kopie anlegen.",
    anzahlRechte: (n: number, von: number) => `${n} von ${von} Rechten`,
    nurClose: "Diese Rechte gibt es nur in Close. Im CRM haben sie keine Wirkung.",
    nurCloseZeigen: "Rechte nur für Close anzeigen",
    nurCloseVerbergen: "Rechte nur für Close ausblenden",
    name: "Name der Rolle",
    kopieren: "Kopie anlegen",
    speichern: "Speichern",
    gespeichert: "Gespeichert.",
    loeschen: "Rolle löschen …",
    loeschenTitel: (name: string) => `Rolle „${name}“ löschen`,
    loeschenText: (n: number) =>
      n === 0 ? "Niemand hat diese Rolle. Sie wird gelöscht." : `${n} ${n === 1 ? "Nutzer wechselt" : "Nutzer wechseln"} in die Rolle, die du hier wählst.`,
    ersatz: "Neue Rolle für die Nutzer",
    geloescht: "Rolle gelöscht.",
    angelegt: "Rolle angelegt.",
    dialogNeu: "Neue Rolle anlegen",
    dialogName: "Name",
    dialogBasis: "Beginnen mit den Rechten von",
    dialogLos: "Anlegen",
    abbrechen: "Abbrechen",
    ungespeichert: "Ungespeicherte Änderungen",
    sichtbarkeit: "Lead-Sichtbarkeit",
    sichtbarkeitText: "Welche Leads die Rolle sieht.",
    sichtbarkeitAlle: "Alle Leads",
    sichtbarkeitEigene: "Leads, bei denen der Nutzer eingetragen ist",
    sichtbarkeitEigeneHilfe: "Steht der Nutzer in irgendeinem Nutzerfeld des Leads (zum Beispiel „Setter“, „CC Termin“) oder hat er den Lead angelegt.",
    sichtbarkeitFelder: "Nur Leads, bei denen der Nutzer in bestimmten Feldern steht",
    sichtbarkeitFelderHilfe: "Bis zu drei Nutzerfelder wählen.",
    sichtbarkeitKeineFelder: "Es gibt keine Nutzerfelder bei den Leads.",
    sichtbarkeitAdmin: "Admins sehen immer alle Leads.",
    sichtbarkeitNochNicht:
      "Die Einstellung ist gespeichert, wirkt aber bisher nur beim Anhören von Aufnahmen. In Listen, Suche, Smart Views, Berichten, Verlauf und Inbox sieht die Rolle weiterhin alle Leads. Bevor du sie für Simon umstellst, muss das eingebaut sein.",
    laden: "Rollen konnten nicht geladen werden",
  },
  sicherheit: {
    zweiFaktor: "Zwei-Faktor-Anmeldung",
    zweiFaktorText:
      "Beim Anmelden fragt das CRM zusätzlich nach einem sechsstelligen Code aus einer Authenticator-App auf deinem Handy (zum Beispiel Google Authenticator, Microsoft Authenticator oder 1Password). Wer dein Passwort kennt, kommt damit allein nicht mehr hinein.",
    status: { an: "Eingeschaltet", aus: "Nicht eingeschaltet", seit: (wann: string) => `seit ${wann}` },
    codesUebrig: (n: number) => `${n} von 10 Wiederherstellungscodes übrig`,
    codesWenig: "Es sind nur noch wenige Wiederherstellungscodes übrig. Erzeuge neue.",
    einschalten: "Einschalten",
    abschaltenKnopf: "Abschalten",
    neueCodes: "Neue Wiederherstellungscodes",
    erzwungenHinweis: "Die Organisation verlangt Zwei-Faktor. Es lässt sich nicht abschalten.",
    einrichten: {
      titel: "Zwei-Faktor einrichten",
      schritt1: "1. Authenticator-App öffnen und den QR-Code scannen",
      schritt1Alt: "Geht das Scannen nicht (zum Beispiel am selben Gerät)? Den Schlüssel von Hand eintragen:",
      appOeffnen: "In der App öffnen",
      schluessel: "Schlüssel",
      zeitbasiert: "zeitbasiert, 6 Stellen",
      schritt2: "2. Den Code aus der App eingeben",
      code: "Sechsstelliger Code",
      bestaetigen: "Einschalten",
      laeuft: "Wird geprüft …",
      abbrechen: "Abbrechen",
      qrFehler: "Der QR-Code konnte nicht gezeichnet werden. Bitte den Schlüssel von Hand eintragen.",
      neu: "Neuen Schlüssel erzeugen",
    },
    codes: {
      titel: "Wiederherstellungscodes",
      text: "Hebe diese Codes sicher auf, zum Beispiel im Passwortmanager oder ausgedruckt. Hast du dein Handy nicht dabei, kommst du mit einem Code hinein. Jeder Code gilt einmal. Hier siehst du sie nur jetzt.",
      kopieren: "Alle kopieren",
      kopiert: "Codes kopiert.",
      herunterladen: "Als Textdatei speichern",
      drucken: "Drucken",
      bestaetigt: "Ich habe die Codes gespeichert",
      fertig: "Fertig",
      dateiname: "crm-wiederherstellungscodes.txt",
      dateiKopf: "Wiederherstellungscodes für das Förderzentrum CRM. Jeder Code gilt einmal.",
    },
    abschalten: {
      titel: "Zwei-Faktor abschalten",
      text: "Zur Sicherheit brauchst du dein Passwort und einen aktuellen Code (oder einen Wiederherstellungscode).",
      passwort: "Passwort",
      code: "Code",
      knopf: "Abschalten",
      ok: "Zwei-Faktor ist abgeschaltet.",
    },
    neueCodesDialog: {
      titel: "Neue Wiederherstellungscodes",
      text: "Die bisherigen Codes werden ungültig. Zur Sicherheit brauchst du dein Passwort und einen aktuellen Code.",
      knopf: "Neue Codes erzeugen",
    },
    organisation: "Für die ganze Organisation",
    erzwingen: "Zwei-Faktor für alle verlangen",
    erzwingenText:
      "Wer es noch nicht hat, muss es bei der nächsten Anfrage einrichten, bevor er weiterarbeitet. Einschalten kannst du nur, wenn du es selbst hast.",
    erzwingenAn: "Zwei-Faktor wird jetzt von allen verlangt.",
    erzwingenAus: "Zwei-Faktor ist wieder freiwillig.",
    zaehlung: (mit: number, gesamt: number) => `${mit} von ${gesamt} aktiven Nutzern haben Zwei-Faktor.`,
    notausgang:
      "Hat jemand sein Gerät verloren: unter Einstellungen › Nutzer „Zwei-Faktor zurücksetzen“. Kann gar niemand mehr anmelden, geht es auf dem Server mit „python -m crm_api.services.zwei_faktor zuruecksetzen --email …“.",
    laden: "Sicherheit konnte nicht geladen werden",
  },
  pflicht: {
    titel: "Bitte Zwei-Faktor einrichten",
    text: "Deine Organisation verlangt Zwei-Faktor für alle. Richte es jetzt ein, dann geht es sofort weiter. Das dauert eine Minute.",
    abmelden: "Abmelden",
  },
  login: {
    code: "Code",
    codeText: "Bitte den sechsstelligen Code aus deiner Authenticator-App eingeben.",
    codeHilfe: "Kein Handy dabei? Einen Wiederherstellungscode eingeben.",
    weiter: "Anmelden",
    zurueck: "Zurück",
  },
  einladungAnnehmen: {
    titel: "Willkommen im CRM",
    text: (email: string, rolle: string) => `Du wurdest mit ${email} als ${rolle} eingeladen. Wähle deinen Namen und ein Passwort.`,
    vorname: "Vorname",
    nachname: "Nachname",
    passwort: "Passwort",
    passwortHilfe: "Mindestens 12 Zeichen. Am besten ein langer Satz.",
    passwort2: "Passwort wiederholen",
    nichtGleich: "Die beiden Passwörter sind nicht gleich.",
    knopf: "Konto anlegen",
    laeuft: "Wird angelegt …",
    ungueltig: "Dieser Einladungslink ist ungültig oder abgelaufen. Bitte lass dir einen neuen schicken.",
    fertigTitel: "Dein Konto ist angelegt",
    fertigText: "Du kannst dich jetzt mit deiner E-Mail-Adresse und dem Passwort anmelden.",
    zumLogin: "Zur Anmeldung",
    laden: "Einladung wird geprüft …",
  },
} as const;
